import * as angular from 'angular';

import { IRequestService } from '../request.service';
import { IUploadService } from '../helpers';
import { IUploadResultApi, IUploadResult, Dictionary, NamedQueriesDto } from '../../models';

export interface IQuerySetService {
    getNamedQueries(): angular.IPromise<Dictionary<NamedQueriesDto>>;
    upload(file: File): angular.IPromise<IUploadResult>;
}

export class QuerySetService implements IQuerySetService {
    static serviceId = 'querySetService';

    private _controllerUrl = 'querySet';

    static $inject = [
        'requestService',
        'uploadService'
    ];

    constructor(
        private _requestService: IRequestService,
        private _uploadService: IUploadService
    ) {
    }

    getNamedQueries(): angular.IPromise<Dictionary<NamedQueriesDto>> {
        return this._requestService.getAtV1(`${this._controllerUrl}/named`);
    }

    upload(file: File): angular.IPromise<IUploadResult> {
        const url = `${this._requestService.getUrlV1()}${this._controllerUrl}/upload`;
        return this._uploadService
            .uploadFile<IUploadResultApi>(url, file)
            .then(data => {
                return { result: data.item1, message: data.item2 };
            });
    }
}